import * as yup from 'yup'

export const rejectApplicationSchema = yup.object().shape({
    comment: yup.string().max(2048).required('Введите комментарий')
})